import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["articles", "subcategories", "translatedToLanguages", "translations"];
import { List, OrderedMap, Record } from 'immutable';
import Article from './../ArticleRecord';
export const oldCategoryEmptyState = {
  articles: OrderedMap(),
  description: undefined,
  fullPath: undefined,
  id: 0,
  isDisplayed: false,
  isFullyTranslated: undefined,
  language: undefined,
  parentId: undefined,
  name: undefined,
  position: undefined,
  state: undefined,
  subcategories: OrderedMap(),
  translatedToLanguages: List(),
  translations: List(),
  totalPublishedArticles: undefined,
  totalArticles: undefined,
  totalSubcategories: undefined,
  convertedToLegacy: false
};
class Category extends Record(oldCategoryEmptyState) {
  static from(_ref) {
    let {
        articles = [],
        subcategories = [],
        translatedToLanguages = [],
        translations = []
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return new Category(Object.assign({
      articles: OrderedMap(articles.map(article => {
        const articleRecord = new Article(article);
        return [articleRecord.values.hs_id, articleRecord];
      })),
      subcategories: OrderedMap(subcategories.map(c => [c.id, Category.from(c)])),
      translatedToLanguages: List(translatedToLanguages),
      translations: List(translations)
    }, rest));
  }
}
export default Category;